(function () {
  var root = document.querySelector('.la-knowledge__article');
  if (!root) return;
  var body = root.querySelector('.la-knowledge__body');
  var contents = root.querySelector('.la-knowledge__contents');
  var headings = body.querySelectorAll('h2');
  if (headings.length > 1 && contents) {
    headings.forEach(function (heading, index) {
      if (!heading.id) heading.id = 'guide-section-' + (index + 1);
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      contents.querySelector('ol').appendChild(item);
    });
    contents.hidden = false;
    root.querySelector('.la-knowledge__reading-grid').classList.add('has-contents');
  }
  // Group each answer so its spacing stays consistent across article formats.
  var answer;
  Array.from(body.children).forEach(function (node) {
    if (node.tagName === 'H2') {
      answer = document.createElement('section');
      answer.className = 'la-knowledge__answer';
      answer.setAttribute('aria-labelledby', node.id);
      body.insertBefore(answer, node);
    }
    if (answer) answer.appendChild(node);
  });
  body.querySelectorAll('table').forEach(function (table) {
    if (table.parentElement.classList.contains('la-knowledge__table-scroll')) return;
    var wrap = document.createElement('div');
    wrap.className = 'la-knowledge__table-scroll';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', table.caption ? table.caption.textContent : (root.closest('[lang]').lang === 'en' ? 'Article table' : '文章表格'));
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });
})();
